/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Schema_S4_Li1Inputs */

const en_guide_json_schema_s4_li1 = /** @type {(inputs: Guide_Json_Schema_S4_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>API Validation</strong>: Validate request bodies before processing (Express, FastAPI, Spring Boot)`)
};

const ko_guide_json_schema_s4_li1 = /** @type {(inputs: Guide_Json_Schema_S4_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>API 유효성 검사</strong>: 처리 전 요청 본문 검증 (Express, FastAPI, Spring Boot)`)
};

const ja_guide_json_schema_s4_li1 = /** @type {(inputs: Guide_Json_Schema_S4_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>APIバリデーション</strong>: 処理前にリクエストボディを検証（Express、FastAPI、Spring Boot）`)
};

/**
* | output |
* | --- |
* | "<strong>API Validation</strong>: Validate request bodies before processing (Express, FastAPI, Spring Boot)" |
*
* @param {Guide_Json_Schema_S4_Li1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_schema_s4_li1 = /** @type {((inputs?: Guide_Json_Schema_S4_Li1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Schema_S4_Li1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_schema_s4_li1(inputs)
	if (locale === "ko") return ko_guide_json_schema_s4_li1(inputs)
	return ja_guide_json_schema_s4_li1(inputs)
});